var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"StoreWithdrawalsView","fluid":"lg"}},[_c('ListWithdrawals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }